var map = {
  "./Idea-Poll-Details-Image.svg": "83807",
  "./NPS-import-review.svg": "61157",
  "./agent-mode-cta.svg": "93973",
  "./ai-idea-generation.svg": "95256",
  "./ai/ai-highlight-icon.svg": "83083",
  "./ai/ai-idea-generation.svg": "77851",
  "./ai/ai-template-action.svg": "98758",
  "./ai/ai-template-map.svg": "35810",
  "./ai/ai-template-pencil.svg": "28639",
  "./ai/ai-templates-background.svg": "77559",
  "./ai/ai-templates-side.svg": "36954",
  "./ai/ai-topic-icon.svg": "30008",
  "./ai/prompt-template-action.svg": "24726",
  "./ai/prompt-template-map.svg": "33010",
  "./ai/prompt-template-pencil.svg": "36911",
  "./ai/prompt-templates-side.svg": "35082",
  "./airtable.svg": "74753",
  "./comments-empty-state.svg": "14239",
  "./confirmation.svg": "66118",
  "./context-onboarding-1.png": "9533",
  "./context-onboarding-2.png": "28326",
  "./csv-import.svg": "38787",
  "./drag_to_reposition.svg": "27606",
  "./email-setup-modal.svg": "56267",
  "./email-visual.svg": "18596",
  "./empty-state-feedback.svg": "26344",
  "./empty-state-portals.png": "7933",
  "./empty-state-summary-with-ai.svg": "68995",
  "./empty-state-summary-without-ai.svg": "9671",
  "./explore-init-sync.png": "55356",
  "./failed-uploads.svg": "78127",
  "./favorite-views-empty.svg": "59880",
  "./feedback-mini-icon.svg": "8902",
  "./feedback-status-update.svg": "88323",
  "./feedback-view-mid-fi.svg": "34335",
  "./feedback/type-feedback-icon.svg": "3373",
  "./funnel.svg": "97301",
  "./google-sheets.svg": "24385",
  "./horizon-search-error.svg": "3814",
  "./hover-card-empty-state.svg": "68040",
  "./idea-list-empty-state.png": "70254",
  "./idea-list-filters-empty-state.svg": "90360",
  "./idea-mini-icon.svg": "84590",
  "./idea-poll-filter-illustration.svg": "7812",
  "./idea-poll-illustration.svg": "48449",
  "./idea-status-update.svg": "74747",
  "./idea-test-multi-page-layout.svg": "15074",
  "./idea-test-single-page-layout.svg": "66013",
  "./ideas-jira-integration.svg": "25017",
  "./import-csv.svg": "84265",
  "./import-guide-polls.svg": "22220",
  "./import-nps.svg": "82396",
  "./import-salesforce.svg": "18018",
  "./import-to-listen.svg": "41072",
  "./in-app-visual.svg": "50407",
  "./insights-page-empty.svg": "47718",
  "./insights-screenshot.svg": "40555",
  "./link-idea-empty.svg": "34411",
  "./loading-csv-items.svg": "33991",
  "./logo-csv-review-step.svg": "32255",
  "./no-guide-selected.svg": "40847",
  "./no-nps-selected.svg": "80652",
  "./no-portal-sharing.svg": "28040",
  "./no-portals-found.svg": "77097",
  "./no-search-results.svg": "84795",
  "./no-selected-idea.svg": "30",
  "./no-templates-filtered-out.svg": "66133",
  "./onboarding-shield.svg": "42476",
  "./pendo-sparkle-upload.gif": "73502",
  "./pendo-sparkles.svg": "40163",
  "./portal-create.svg": "37316",
  "./promote-idea.svg": "9857",
  "./quick-start-header.svg": "28341",
  "./roi-page-arrows.svg": "69446",
  "./roi-page-empty-bg.png": "38374",
  "./save-feedback-view-modal-side.svg": "85364",
  "./source-icon/API-icon-withname.svg": "58855",
  "./source-icon/API-icon.svg": "27961",
  "./source-icon/CSV-icon-withname.svg": "56687",
  "./source-icon/CSV-icon.svg": "78401",
  "./source-icon/Gong-icon-withname.svg": "24106",
  "./source-icon/Gong-icon.svg": "88746",
  "./source-icon/Hubspot-icon.svg": "72054",
  "./source-icon/Intercom-icon.svg": "86064",
  "./source-icon/NPS-icon-withname.svg": "50962",
  "./source-icon/NPS-icon.svg": "88722",
  "./source-icon/Salesforce-icon-withname.svg": "41716",
  "./source-icon/Salesforce-icon.svg": "21451",
  "./source-icon/SlackMessages-icon-withname.svg": "56895",
  "./source-icon/SlackMessages-icon.svg": "10577",
  "./source-icon/Teams-icon-withname.svg": "94501",
  "./source-icon/Teams-icon.svg": "49467",
  "./source-icon/ZendeskTickets-icon-withname.svg": "92850",
  "./source-icon/ZendeskTickets-icon.svg": "7698",
  "./source-icon/Zoom-icon-withname.svg": "52164",
  "./source-icon/Zoom-icon.svg": "69096",
  "./source-icon/feedbackV1-icon-withname.svg": "31767",
  "./source-icon/feedbackV1-icon.svg": "46697",
  "./source-icon/g2-icon.svg": "81758",
  "./source-icon/guide-icon-withname.svg": "66835",
  "./source-icon/guide-icon.svg": "43629",
  "./source-icon/internalForm-icon-withname.svg": "60016",
  "./source-icon/internalForm-icon.svg": "11612",
  "./source-icon/pendo-icon.svg": "29079",
  "./source-icon/portal-icon-withname.svg": "84595",
  "./source-icon/portal-icon.svg": "78797",
  "./source-icon/source-pendo-icon.svg": "64121",
  "./source-icon/surveys-icon-withname.svg": "47638",
  "./source-icon/surveys-icon.svg": "10014",
  "./source-icon/unknown-icon.svg": "87591",
  "./sources-background.png": "60049",
  "./states/loading-chart.svg": "12685",
  "./subscriber-list.svg": "83340",
  "./successful-uploads.svg": "91554",
  "./template.svg": "67647",
  "./tip-background.svg": "67433",
  "./voc-feedback-form-background.svg": "54553",
  "./voc-portal-rc-listen.svg": "8929",
  "./voc-portal-rc-preview.svg": "41577",
  "./workarounds.svg": "21468"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 7048;
